import {
  array,
  email,
  literal,
  maxLength,
  minLength,
  minValue,
  object,
  optional,
  record,
  setSpecificMessage,
  string,
} from 'valibot'

import { sprintfTranslate } from '@/utils/locale'

export function initValibotMessages(t: (key: string) => string): void {
  setSpecificMessage(string, () => t('This field cannot be empty'))

  setSpecificMessage(minLength, (issue) => {
    if (issue.requirement && issue.requirement !== 1) {
      return sprintfTranslate(t('Min %s symbols'), [issue.requirement.toString()])
    }
    return t('This field cannot be empty')
  })

  setSpecificMessage(maxLength, (issue) => {
    if (issue.requirement && issue.requirement !== 1) {
      return sprintfTranslate(t('Max %s symbols'), [issue.requirement.toString()])
    }
    return t('The field contents are invalid')
  })

  setSpecificMessage(email, () => t('Invalid email. Please input a proper email'))

  setSpecificMessage(minValue, (issue) => `${t('Min')} ${issue.requirement}`)
}

export const errorSchema = object({
  error_message: string(),
  errors: optional(record(string(), array(string()))),
  status: literal('error'),
})

export const successSchema = object({
  status: literal('success'),
})
